/** @format */

import { SkuDefiningAttribute } from './sku-defining-attribute.interface';

export interface ATCEventChildSku {
  definingAttributes: SkuDefiningAttribute[];
  price?: number;
  productId?: string;
  skuId?: string;
  title: string;
}
